(() => {
  if (window.wncCardColorsReady) return;
  window.wncCardColorsReady = true;
  const mediaMaps = new WeakMap();
  const initializedControls = new WeakSet();

  function colorImage(button) {
    const controls = button.closest('[data-wnc-card-colors]');
    const metadata = controls?.querySelector('[data-wnc-card-color-media]');
    if (metadata) {
      if (!mediaMaps.has(controls)) {
        try {
          mediaMaps.set(controls, JSON.parse(metadata.textContent));
        } catch {
          mediaMaps.set(controls, null);
        }
      }
      const catalog = mediaMaps.get(controls);
      const ids = catalog?.colors?.[button.dataset.colorName];
      if (Array.isArray(ids) && Array.isArray(catalog.images)) {
        const shared = Array.isArray(catalog.colors['*']) ? catalog.colors['*'] : [];
        for (const id of [...ids, ...shared]) {
          const image = catalog.images.find(candidate => String(candidate.id) === String(id));
          if (image) return image;
        }
        return null;
      }
    }
    if (!button.dataset.imageSrc) return null;
    return {
      src: button.dataset.imageSrc,
      srcset: button.dataset.imageSrcset || '',
      width: Number(button.dataset.imageWidth) || 960,
      height: Number(button.dataset.imageHeight) || 960,
      alt: button.dataset.imageAlt || ''
    };
  }

  function priceText(label, amount) {
    const fragment = document.createDocumentFragment();
    if (label) {
      const description = document.createElement('span');
      description.className = 'visually-hidden';
      description.textContent = label;
      fragment.append(description);
    }
    fragment.append(document.createTextNode(amount));
    return fragment;
  }

  function updatePrice(card, button) {
    const price = Number(button.dataset.price);
    const compare = Number(button.dataset.comparePrice);
    const discounted = compare > price;
    const container = card.querySelector('.price__container');
    if (container) {
      const wrapper = document.createElement('div');
      wrapper.className = discounted ? 'price__sale' : 'price__regular';
      if (discounted) {
        const inner = document.createElement('div');
        inner.className = 'price__sale-inner';
        const previous = document.createElement('s');
        previous.append(priceText(container.dataset.labelPriceRegular, button.dataset.compareFormatted));
        const current = document.createElement('ins');
        current.append(priceText(container.dataset.labelPriceSale, button.dataset.priceFormatted));
        inner.append(previous, current);
        wrapper.append(inner);
      } else {
        wrapper.append(priceText(container.dataset.labelPriceRegular, button.dataset.priceFormatted));
      }
      container.replaceChildren(wrapper);
    }
    card.querySelectorAll('.product-card__badge--discount').forEach(badge => {
      badge.classList.toggle('hidden', !discounted);
      const percentage = badge.querySelector('.percentage');
      if (percentage && discounted) percentage.textContent = String(Math.round((compare - price) / compare * 100));
    });
    card.querySelectorAll('[data-wnc-installments]').forEach(installments => {
      if (installments.dataset.template && button.dataset.installmentFormatted) {
        installments.innerHTML = installments.dataset.template.replace('__AMOUNT__', button.dataset.installmentFormatted);
      }
    });
  }

  function updateImage(card, button, eager = true) {
    const media = card.querySelector('.product-card__media');
    const preview = colorImage(button);
    if (!media) return;
    media.classList.add('wnc-card-color-selected');
    media.classList.remove('product-card__media--hoverable');
    let image = media.querySelector('[data-wnc-card-preview-image]');
    if (!preview?.src) {
      image?.remove();
      media.dataset.wncColorImageMissing = '';
      return;
    }
    delete media.dataset.wncColorImageMissing;
    if (!image) {
      image = document.createElement('img');
      image.dataset.wncCardPreviewImage = '';
      media.append(image);
    }
    image.loading = eager ? 'eager' : 'lazy';
    image.srcset = preview.srcset || '';
    image.sizes = '(min-width: 990px) 25vw, 50vw';
    image.src = preview.src;
    image.width = Number(preview.width) || 960;
    image.height = Number(preview.height) || 960;
    media.querySelectorAll('.wnc-card-color-image').forEach(previous => previous.classList.remove('wnc-card-color-image'));
    image.classList.remove('hidden');
    image.classList.add('wnc-card-color-image');
    image.alt = preview.alt || button.dataset.imageAlt || '';
  }

  function selectColor(button, eager = true) {
    const card = button.closest('product-card');
    const controls = button.closest('[data-wnc-card-colors]');
    if (!card || !controls || !button.dataset.variantId) return;
    controls.querySelectorAll('[data-wnc-card-color]').forEach(candidate => {
      candidate.setAttribute('aria-pressed', String(candidate === button));
    });
    const label = controls.querySelector('[data-wnc-card-color-label]');
    if (label) label.textContent = button.dataset.colorName;
    card.querySelectorAll('[data-product-link]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', button.dataset.variantId);
      link.href = url.toString();
    });
    card.querySelectorAll('input[name="id"]').forEach(input => { input.value = button.dataset.variantId; });
    updateImage(card, button, eager);
    updatePrice(card, button);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-wnc-card-color]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    selectColor(button);
  });

  function initializeColors(root) {
    const controls = [];
    if (root.matches?.('[data-wnc-card-colors]')) controls.push(root);
    root.querySelectorAll?.('[data-wnc-card-colors]').forEach(control => controls.push(control));
    controls.forEach(control => {
      if (initializedControls.has(control)) return;
      const card = control.closest('product-card');
      const selected = control.querySelector('[data-wnc-card-color][aria-pressed="true"]');
      if (!card || !selected) return;
      initializedControls.add(control);
      selectColor(selected, false);
    });
  }

  function startPreviews() {
    initializeColors(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) initializeColors(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startPreviews, { once: true });
  else startPreviews();
})();

